/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";
import { CmpPlancard } from "../CmpPlancard";
import "./style.css";

export const CardPlanweekheader = ({ className }) => {
  return (
    <div className={`card-planweekheader ${className}`}>
      <CmpPlancard
        className="cmp-plancard-instance"
        divClassName="design-component-instance-node"
        text="Week 1"
        text1="Walk and Stretch"
        weekState="current"
      />
    </div>
  );
};
